import EmptyState from '@/components/EmptyState';
import { useCan } from '@/hooks/useAbility';
import { useT } from '@/i18n';
import { useSettingsDetailBackLink } from '@/utils/useMediaQuery';
import { Navbar, Page } from 'framework7-react';
import type { ReactNode } from 'react';

interface PurgeAccessGateProps {
  title: string;
  children: ReactNode;
}

function PurgeAccessGate({ title, children }: PurgeAccessGateProps) {
  const t = useT().purge;
  const settingsBackLink = useSettingsDetailBackLink();
  const canManagePurge = useCan('manage', 'PurgeRun');

  if (!canManagePurge) {
    return (
      <Page name="purge-no-access">
        <Navbar title={title} backLink={settingsBackLink} />
        <EmptyState icon="lock" iconColor="#8e8e93" title={t.noAccess} />
      </Page>
    );
  }

  return <>{children}</>;
}

export default PurgeAccessGate;
